/**
 * NZSC-3062: 셜록 동의 외부 페이지 정적 카피 상수.
 *
 * 기존에 `sherlock-delinquency.js`(stub) 와 `ConsentExternalView.vue`(템플릿 fallback) 두 곳에
 * 중복 정의되어 있던 정적 카피를 단일 소스로 추출. 추후 BE 가 동적 발급 기관/조회 정보를
 * 응답에 포함하면 fallback 으로만 활용된다.
 *
 * 셜록 격리: 도비/카우 미참조. 본 모듈은 셜록 동의 외부 페이지 전용.
 */
export default {
  /** 요청 기관 — 현재는 회사 자체. BE 가 requesterName 내려주면 그것 우선. */
  REQUESTER_NAME: "한국부동산데이터연구소",
  /** 조회 범위 안내 문구. */
  SCOPE_TEXT: "국세/지방세 체납, 채무 불이행 등 거래 신뢰도 관련 이력",
  /** 요청 사유 안내 문구. */
  PURPOSE: "거래 안전성에 영향을 줄 수 있는 세금 체납 및 채무 불이행 이력 등에 대한 정보 확인",
};
